/* eslint-disable */
import React from "react";

const RaindropInputDropdown = ({
  options,
  label = "",
  value = "",
  onChange,
  isEditing = true,
}) => {
  let padding = "py-1 px-2";
  let border =
    "border dark:border-color-dark-border-primary border-color-border-primary";
  let hideArrow = "";

  if (!isEditing) {
    padding = "py-1 px-0";
    border = "";
    hideArrow = "appearance-none";
  }

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="text-color-dark-text-tertiary text-xs text-left">
          {label}
        </label>
      )}

      <div
        className={`bg-transparent  ${border} ${padding} rounded-lg text-color-dark-text-secondary font-bold  w-full`}
      >
        <select
          value={value}
          onChange={onChange}
          className={`bg-transparent w-full outline-none ${hideArrow} `}
          disabled={!isEditing}
        >
          {options.map((option, index) => (
            <option key={index} value={option[0]}>
              {option[1]}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default RaindropInputDropdown;
